<ng-container *ngIf="!list.is_archived">
  <ul
    class="c-list-status-panel list-unstyled"
    *ngIf="!canViewReviewStatusForCurrentList"
  >
    <li class="c-list-status-panel__item">
      <rl-list-status
        [list]="list"
        [editableList]="editableList"
        [permissions]="permissions"
      ></rl-list-status>
    </li>
    <li class="c-list-status-panel__item">
      <rl-list-status-description
        [list]="list"
        [editableList]="editableList"
      ></rl-list-status-description>
    </li>
    <li class="c-list-status-panel__item">
      <rl-list-saving-status
        [listPublishingStatus]="listPublishingStatus"
        [queueSize]="queueSize"
      ></rl-list-saving-status>
    </li>
    <li class="c-list-status-panel__item" *ngIf="hasActiveReview">
      <span
        class="qa-list-status-panel__review-requested"
        i18n="@@listStatusPanel-text-reviewRequested"
        >Review requested.</span
      >
    </li>
    <li
      class="c-list-status-panel__item"
      *ngIf="hasActiveReview && canReviewCurrentList"
    >
      <a
        [href]="editableList.activeReviewUrl"
        target="_blank"
        class="qa-list-status-panel__view-review"
        i18n="@@listStatusPanel-link-viewReview"
        >View review</a
      >
    </li>
  </ul>
  <rl-list-status-review
    *ngIf="canViewReviewStatusForCurrentList"
    [list]="list"
    [editableList]="editableList"
  ></rl-list-status-review>
</ng-container>
